var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plainImage",staticStyle:{"min-width":"50px","background-position-x":"top","background-position-y":"center"},style:({ ..._vm.props.styles, backgroundImage: `url('${'https://admin.tumar.com/' + _vm.props.src}')` })})
}
var staticRenderFns = []

export { render, staticRenderFns }